// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function Line5px(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "Line5px" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.98218 18.4824L18.4822 1.98242L22.0177 5.51796L5.51771 22.018L1.98218 18.4824Z", fill: "currentColor" }))));
});
//# sourceMappingURL=Line5px.js.map